import React, { useContext } from 'react'
import { View } from 'oio-react'
import Logo from 'src/apps/Global/components/MainMenu/Logo'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import IconDrawerMenuButton from '~/components/MainMenu/IconDrawerMenuButton'
import IconSearchButton from '~/components/MainMenu/IconSearchButton'

const MobileMainMenu = () => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)

   return (
      <View
         display="flex[a-c] none[d-f]"
         justifyContent="space-between[a-d]"
         alignItems="center"
         width="100%"
         height="70px"
         backgroundColor={theme.tmpMainMenuBackgroundColor}
         paddingHorizontal={theme.tmpViewportPadding}
         borderBottom={`1px solid ${theme.tmpBorderColor}`}>
         <Logo />
         <View display="flex" alignItems="center">
            <IconSearchButton
               color={theme.tmpMainMenuTextColor}
               size="20px"
            />
            <IconDrawerMenuButton
               color={theme.tmpMainMenuTextColor}
               display="flex"
            />
         </View>
      </View>
   )
}

export default MobileMainMenu
